import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import Collapsible from 'react-collapsible';
import CollapsibleContainer from '../../components/CollapsibleContainer';
import UpperContainer from '../../components/UpperContainer';
import { animateToScreen } from '../../redux/ui/actions';
import TextColumnContent from '../../molecules/TextColumnContent';
import BackButtonContainer from '../../molecules/BackButtonContainer';
import Description from '../../components/Description';
import { H2, Text } from '../../components/Typography';

class ExtraTicketPassengersTexts extends PureComponent {
  render() {
    const { t } = this.props;
    return (
      <>
        <BackButtonContainer
          home={t('Generic.breadcrumbHome')}
          homeLink={t('Generic.breadcrumbHomeLink')}
          secondaryHome={t('Generic.breadcrumbSecondaryHome')}
          secondaryHomeLink={t('Generic.breadcrumbSecondaryHomeLink')}
          textPrev={t('Flows.home')}
          text={t('Flows.extraTicket')}
          onClick={() => animateToScreen('Home')}
        />
        <TextColumnContent paddingTop={-80} hasBackButton>
          <H2>
            <Trans i18nKey="ExtraTicketPassengers.title" />
          </H2>
          <UpperContainer>
            <Description>
              <Text>
                <Trans i18nKey="ExtraTicketPassengers.description" />{' '}
              </Text>
            </Description>
          </UpperContainer>
          <CollapsibleContainer>
            <Collapsible
              trigger={t('Generic.additionalInfo')}
              transitionTime={300}
            >
              <Description>
                <Text>
                  <Trans i18nKey="ExtraTicketPassengers.description" />{' '}
                </Text>
              </Description>
            </Collapsible>
          </CollapsibleContainer>
        </TextColumnContent>
      </>
    );
  }
}

ExtraTicketPassengersTexts.propTypes = {
  t: PropTypes.func.isRequired,
};

// prettier-ignore
export default ExtraTicketPassengersTexts;
